import React, { useContext } from 'react';
import { Row, Col, Image } from '@thd-olt-component-react/core-ui';
import { DataContext } from '../../contexts/DataContext';
import * as CardUtils from '../../common/utils/cardUtils';
import { WelcomeCardHeader } from '../WelcomeCardHeader/WelcomeCardHeader';
import { NotificationSection } from '../NotificationSection';
import { WelcomeCardErrorPage } from '../WelcomeCardErrorPage/WelcomeCardErrorPage';
import { getImageURL, getHostCURL } from '../../common/utils/cardUtils';

const exportsForTesting = {};

const TabletWelcomeCard = (props) => {
  const { isLoading, tiles, userDataError } = useContext(DataContext);
  const { handleOnClick } = props;
  const isAdmin = CardUtils.getUserRole() === 'ADMIN';
  const learnMoreLink = isAdmin ? getHostCURL('/myaccount/proxtraprogramdetails') : getHostCURL('/c/pro_xtra');
  const linkText = isAdmin ? 'See Your Member Benefits' : 'Learn More About Pro Xtra';
  const Card = () => {
    return (
      <div className="loyalty-welcome">
        <div className="header-main">
          <div><WelcomeCardHeader /></div>

          <a
            className="header-label"
            href={learnMoreLink}
            rel=" noreferrer"
          >{linkText}
          </a>
          <div>
            <a
              className="header-label"
              href={learnMoreLink}
              rel=" noreferrer"
            >
              <Image
                width="8"
                height="16"
                src={getImageURL('caret-small.svg')}
                alt="Orangee Arrow"
                className="arrow-orange"
              />
            </a>
          </div>

        </div>
        <div className="notifcation-main">
          <NotificationSection tiles={tiles.NOTIFICATION} />
        </div>
      </div>
    );
  };

  const RenderTabletWelcomeCard = () => {
    return (
      <Row xs="12" sm="12" md="12" lg="12" data-component="LoyaltyBenefits">
        {(!isLoading && !userDataError)
          ? <Card />
          : (
            <WelcomeCardErrorPage
              handleOnClick={handleOnClick}
              cardLoaded={!isLoading}
            />
          )}
      </Row>
    );
  };

  exportsForTesting.handleOnClick = handleOnClick;
  exportsForTesting.Card = Card;
  exportsForTesting.RenderTabletWelcomeCard = RenderTabletWelcomeCard;

  return <RenderTabletWelcomeCard />;
};

export { TabletWelcomeCard, exportsForTesting };
